import { IExportStrategy, IExportStrategyConfig } from "./types";
import { IExportOrdersValues } from "../../interfaces/order";

export abstract class BaseExportStrategy implements IExportStrategy {
  protected marketplaceId?: string;

  constructor(marketplaceId?: string) {
    this.marketplaceId = marketplaceId;
  }

  abstract getConfig(): IExportStrategyConfig;

  getCarriersEndpoint(): string {
    return this.getConfig().carriersEndpoint;
  }

  getFilesEndpoint(marketplaceId?: string): string {
    const base = `/${this.getConfig().ordersEndpoint}/files?type=summary`;
    return marketplaceId ? `${base}&marketplaceId=${marketplaceId}` : base;
  }

  getSummaryEndpoint(): string {
    return `/${this.getConfig().ordersEndpoint}/summary`;
  }

  buildSubmitBody(values: IExportOrdersValues, marketplaceId?: string): object {
    if (this.getConfig().needsMarketplaceId && marketplaceId) {
      return { ...values, marketplaceId };
    }
    return values;
  }

  shouldFetchMerchants(): boolean {
    return this.getConfig().needsMerchants;
  }

  shouldFetchAliases(): boolean {
    return this.getConfig().needsAliases;
  }

  shouldFetchClients(): boolean {
    return this.getConfig().needsClients;
  }
}
